<template>
 
   <div   style="background:#fff!important">


<div style="padding:13px 14px;;position:fixed;bottom:54px;left:0;right:0;background: #F6F6FA;z-index:10000000;
border-radius: 3px;" class="d-md-none d-flex justify-content-between"  >

  <div class="mr-5">

      <p  class="itmtotal" style="font-family: 'Nunito', sans-serif;font-weight:700;font-size:17px;color:#0B0A23;transform:translateY(2px)"  id="totalpay">₹ {{totalvalues}}</p>
          <p style="color:#EB3838;font-size:14px;font-weight:600;transform:translateY(-2px)">View Price Details</p>



        

  </div>
 



  <div v-if="tab=='address'" v-on:click="changetab('paymentmode')" style="background:#EB3838;font-size:13px;font-weight:700;text-align:center;border-radius:5px;color:#fff; cursor:pointer;padding:12px 20px;flex:1"  >
  Continue
  </div>

    <div v-if="tab=='paymentmode' && !payloader" v-on:click="placeorder" style="background:#EB3838;font-size:13px;font-weight:700;text-align:center;border-radius:5px;color:#fff; cursor:pointer;padding:12px 20px;flex:1"  >
  Place Order
  </div>

  <div v-if="payloader" style="background:#EB3838;font-size:13px;font-weight:700;text-align:center;border-radius:5px;color:#fff; cursor:pointer;padding:12px 20px;flex:1"  >
  <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" style="height:50px">
  </div>






 

</div>



<div v-if='addbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-md-flex d-none justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='closeaddbox'></div>   <div style="width:455px;position:relative;z-index:100000000;">
        
        <div style="padding:33px" class="loginwrapper">

            <form  v-on:submit.prevent='addaddress'>
              <div class="d-flex align-items-center justify-content-between"  >
                <p style="font-size: 18px;font-weight:700;color: #0B0A23;">Add Address</p>
                <i class='bx bx-x' style="color:#0B0A23;font-size:25px;cursor:pointer!important" v-on:click='closeaddbox'></i>
              </div>


              <div class="pt-2"> 

                  <div style="width:100%;padding-right:0px">
                  
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" placeholder="Enter Name" style="font-size:16px;color:#1a181e;    height: 50px;;font-weight:300" v-model='addrnames' name="">
                    </div>
                    
                  </div>
                   <div style="width:100%;padding-left:0px">
                    
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" placeholder="Enter Mobile Number" style="font-size:16px;color:#1a181e;    height: 50px;;font-weight:300"  v-model='addrmobile' name="">
                    </div>
                  </div>
    

                 
                  
                  <div style="width:100%;padding-right:0px">
                   
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" v-model='addrpincode' placeholder="Enter Pincode" style="font-size:16px;color:#1a181e;    height: 50px;;font-weight:300" name="">
                    </div>
                    
                  </div>
                   <div style="width:100%;padding-left:0px">
                    
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" placeholder="Enter City" v-model='addrcity' style="font-size:16px;color:#1a181e;    height: 50px;;font-weight:300" name="">
                    </div>
                  </div>
               
                  
                   <div style="width:100%;padding-left:0px">
                     
                    <div style="" class="inpbor">
                      <textarea required=""  type="text" class="form-control placeaddr" placeholder="Enter Address" v-model='addraddress' style="font-size:16px;color:#1a181e;    height: 50px;;font-weight:300;min-height:80px" name=""></textarea>
                    </div>
                  </div>
              
              </div>



 

                   

 
                              <div class="mt-4 ">

                                <button v-if='!edit'   class="btn loggrn" style=" background: #EB3838;border-radius: 5px;cursor:pointer;font-weight: bold;
font-size: 16px;
font-weight:700;
padding:10px;
width:100%;
text-align: center;

color: #FFFFFF;
 "   >Add Address</button>
                                   <button v-else class="btn loggrn" style=" background: #EB3838;border-radius: 5px;cursor:pointer;font-weight: bold;
font-size: 16px;
font-weight:700;
padding:10px;
width:100%;
text-align: center;

color: #FFFFFF;
 "  >Edit Address</button>
                              
                               
                              </div>
                              

            </form>
          
        </div>
    
  </div>



</div>











<div v-if='addbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-md-none d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='closeaddbox'></div>
  <div style="width:670px;position:relative;z-index:100000000;">
        
        <div style="padding:33px" class="loginwrapper">

           

            <form  v-on:submit.prevent='addaddress' >
              <div class="d-flex align-items-center justify-content-between" style="margin-top:15px">
                <p style="font-size: 18px;font-weight:700;color: #0B0A23;">Add Address</p>
                <i class='bx bx-x' style="color:#0B0A23;font-size:25px;cursor:pointer!important" v-on:click='closeaddbox'></i>
              </div>


              <div class="pt-2"> 

                  <div style="width:100%;padding-right:0px">
                  
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" placeholder="Enter Name" style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300" v-model='addrnames' name="">
                    </div>
                    
                  </div>
                   <div style="width:100%;padding-left:0px">
                    
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" placeholder="Enter Mobile Number" style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300"  v-model='addrmobile' name="">
                    </div>
                  </div>
    

                 
                  
                  <div style="width:100%;padding-right:0px">
                   
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" v-model='addrpincode' placeholder="Enter Pincode" style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300" name="">
                    </div>
                    
                  </div>
                   <div style="width:100%;padding-left:0px">
                    
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" placeholder="Enter City" v-model='addrcity' style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300" name="">
                    </div>
                  </div>
               

                 <div style="width:100%;padding-left:0px">
                    
                    <div  class="inpbor">
                      <input required=""  type="text" class="form-control placeaddr" placeholder="Enter Address" v-model='addraddress' style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300" name="">
                    </div>
                  </div>
               
                 
              
              </div>



 

                   

 
                              <div class="mt-2 ">

                                <button v-if='!edit'   class="btn loggrn" style=" background: #EB3838;border-radius: 5px;cursor:pointer;font-weight: bold;
font-size: 16px;
font-weight:700;
padding:10px;
width:100%;
text-align: center;

color: #FFFFFF;
 "   >Add Address</button>
                                   <button v-else class="btn loggrn" style=" background: #EB3838;border-radius: 5px;cursor:pointer;font-weight: bold;
font-size: 16px;
font-weight:700;
padding:10px;
width:100%;
text-align: center;

color: #FFFFFF;
 "  >Edit Address</button>
                              
                               
                              </div>
                              

            </form>
          
       

          
        </div>
    
  </div>


</div>














 





<div v-if='apply'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='apply=false'></div>
  <div style="width:565px;position:relative;z-index:100000000;">
        
        <div style="" class="loginwrapper">

            <form  v-on:submit.prevent='addaddress'>
              <div class="d-flex align-items-center justify-content-between">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Apply Coupon</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='apply=false'></i>
              </div>


              <div class="pt-2">
                
                
                
                 <div class="d-flex align-items-start mt-md-4 mt-2" style=" ">
                  
                  
                   <div style="width:100%;padding-left:0px">
                   
                    
                    <form v-on:submit.prevent='checkcoupon' style="" class="d-flex align-items-center pr-md-4 pr-0 inpapply">
                      <div  style="flex:1">
                       
                      
                      <input required=""  type="text" class="form-control coupinput" placeholder="Enter coupon code" v-model='coupontext' style="" name=""> 
                      </div>

                     <button v-if='coupontext.length>0' style="border:none;box-shadow:none;outline:none;background:#fff;color:#ee741f;font-size:16px;text-transform:uppercase;cursor:pointer" >Apply</button>

                      <p  v-else style="color:#ee741f;opacity:0.5;font-size:16px;text-transform:uppercase;" >Apply</p>

                    </form>
                    <p v-if='notavailable' style="color:#e50b20;font-size:12px;font-weight:400;margin-top:5px">Sorry! This coupon code is not applicable.</p>

                    <div class="mt-md-4 mt-3">
                      <p style="font-size:13px!important ;font-weight:300" class="mb-4">Available Coupons</p>

                          <template v-for='itm in coupons'>
                            
                         
                      <div class="mb-md-4 mb-2 mt-md-0 mt-4">
                        <div class="d-flex align-items-end justify-content-between mb-2">
                          <div style="color:#ee741f;border:1px solid #ee741f;background:#fcf0e6;padding:2px 10px;border-radius:3px;font-weight:500;font-size:14px;text-transform:uppercase">{{itm.couponcode}}</div>

                           <p style="" class="applybtn" v-on:click='applycoupon(itm)'>Apply</p>
                        </div>

                        <p style="color:#1a181e;font-size:13px!important;font-weight:300"><span style="font-family: 'Montserrat', sans-serif;">₹</span>{{itm.discountamount}} off on all orders above <span style="font-family: 'Montserrat', sans-serif;">₹</span>{{itm.minorderamount}}  </p>
                        <p style="color:#808080;font-size:12px!important;font-weight:200" class="mt-1">Applicable only  once per user</p>
                      </div>
                    </template>
                     



                    </div>
                  </div>
                </div>
              </div>



 
 
                              

            </form>
          
        </div>
    
  </div>


</div>




















<div v-if='deletebox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='deletebox=false'></div>
  <div style="width:360px;position:relative;z-index:100000000;">
        
        <div style="padding:33px" class="loginwrapper">

            
              <div class="d-flex align-items-center justify-content-between">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Delete this address?</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='deletebox=false'></i>
              </div>


                              <div class="d-flex align-items-center justify-content-center">

                                <button v-on:click='finaldelete'    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#E63631;padding:9px 25px;margin-top:30px;font-size:15px;cursor:pointer "  >Delete</button>
                                 
                              </div>
                              


             



 

                   

  

         
          
        </div>
    
  </div>


</div>










 


<div v-if='loginbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='loginbox=false'></div>
  <div v-if="logintype=='send'" style="width:470px;position:relative;z-index:100000000">
        
        <div style="" class="loginwrapper">

            <form  v-on:submit.prevent='login'>
              <div class="d-flex align-items-center justify-content-between mt-md-0 mt-3">
                <p style="font-size: 18px;
    font-weight: 700;
    color: rgb(11, 10, 35);">Enter Mobile Number</p>
                <i class='bx bx-x' style="    color: rgb(11, 10, 35);
    font-size: 25px;
    cursor: pointer !important;" v-on:click='closeloginbox'></i>
              </div>


                            <div style="position: relative;    background: #FFFFFF!important;
    border: 1px solid #E7E5F2!important;
    border-radius: 5px;!important" class='labhead  d-flex align-items-center '  id="hideinputl">
                              <p style="padding-left:10px;color:rgb(11, 10, 35);font-weight:600" class="p91">+91 </p><span style="height:50px;width:1px;background:rgb(231 229 242 / 60%);margin:0px 15px;"></span>
                              
                              <div style="flex:1" class="d-md-block d-none">
                                
                        
                            <input autofocus=""  type="text" placeholder="Enter your mobile number" name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
                           
                                  </div>


                                     

                                      <div style="flex:1;position:relative" class="d-md-none d-block">
                                
                         
                             <input  autofocus=""  type="number" id="phonenumber" placeholder="Enter your mobile number"  name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
 
                    
                           
                                  </div>




                        





                          </div>
                              <div id="recaptcha-container"></div>

                   

    <div class="d-flex align-items-center justify-content-center martp" style="" v-if='!sendotpclicked' >

                                <button    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px;font-size:15px;cursor:pointer " v-if='phone.length==10'  >Send Otp</button>
                                <button disabled=""  class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px; font-size:15px;cursor:pointer "   v-if='phone.length!=10' >Send Otp</button>
                              </div>

                               <div class="d-flex align-items-center justify-content-center martp" v-if='sendotpclicked' >

                                  <button    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px;font-size:15px;cursor:pointer "  >
                                  <img src="./images/signinloader.svg" style="width:30px">
                                </button>
                              </div>

            </form>
          
        </div>
    
  </div>











  <div v-if="logintype=='otp'" style="width:500px;position:relative;z-index:100000000">
        
        <div  class="loginwrapper">

            

              <div class="d-flex align-items-center justify-content-between  mar40"  >

                 <p style="font-size: 18px;
    font-weight: 700;
    color: rgb(11, 10, 35);">OTP Verification</p>
                <i class='bx bx-x' style="    color: rgb(11, 10, 35);
    font-size: 25px;
    cursor: pointer !important;" v-on:click='closeloginbox'></i>



               
              </div>

                      
       

            <div  class="otpboxes  " style="">
    <v-otp-input
      inputClasses="otp-input"
      :numInputs="6"
       separator=""
      :shouldAutoFocus="true"
                  @on-complete="subotp"
       
    />
  </div>
                           

                     
 

<div class="d-flex align-items-center justify-content-center">
  

      <button   class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px; font-size:15px;cursor:pointer " v-on:click='subotps'   v-if='otpenterd' >Login</button>
      </div>
 

  <p v-if='perrs' style="text-align:center;color:red">{{otptext}}</p>
 
                                 

                   
 
                              

       
          
        </div>
    
  </div>




</div>




<!--
 
  
   <div v-if='!loadstatus' style="z-index:100000000000000;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.3)" class="d-flex align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://shop.websitelearners.com/static/img/loader.0395a07.gif" class="img-fluid" style="width:100%">
   </div>
 </div>
-->

 
   <div v-if='orderplaced' style="z-index:100000000000000;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.3)" class="d-flex align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://shop.websitelearners.com/static/img/loader.0395a07.gif" class="img-fluid" style="width:100%">
   </div>
 </div>






  <div  >
 
<div    style="" class="heads"> 





<div style="z-index: 10000;position: fixed;bottom: 0;left: 0;right: 0;padding:10px 27px;background: #fff;" class="d-md-none d-flex align-items-center justify-content-between">


  






  <div
 
v-bind:class="[{ botactive: $route.path.toLowerCase()=='/'+info.name.toLowerCase()},{ botnotactive: $route.path.toLowerCase()!='/'+info.name.toLowerCase() },{navclass:true}]"  >


    <router-link to='/'  style='text-decoration:none'>

 <img src="./images/files/homeblack.svg" style="transform:translateY(-1px)" >



</router-link>
</div>


 
 





   <div  class="botactive navclass"   style="position:relative">
    <router-link to='/bag'  style='text-decoration:none'>

<div style="width:16px;height:16px;background:#fff;border-radius:50%; z-index:10000;   position: absolute;
    top: 3px;
    right: 4px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#EB3838;font-size:10px;font-weight:700">{{rendercartlength}}</span>
</div>
 <img src="./images/files/bagwhite.svg"  style="width:20px;transform:translateY(-1px)" >

  </router-link>
  </div>




   <div v-bind:class="[{ botactive:$route.path=='/'+$route.path.split('/')[1]+'/account'  },{ botnotactive: !($route.path=='/account') },{navclass:true}]" v-on:click='account'>
        

 <img src="./images/files/user.svg" style="width:20px;transform:translateY(-1px)"   >
 
  </div>
   
</div>


 

<!-- heaaderr -->

  
<div  class="  pt-md-4 pb-md-4 pt-3 pb-3  headerwrapper d-flex" style=" background:#fff;z-index:10000000">
  <div class="container pad  " >

  <div class="headerui     ">
    <router-link  to='/'  style='text-decoration:none'>
<div class="d-flex align-items-center mr-4  logowrapper">
    <img src="./images/finallogo.png" style="" class="logohigh">
  <div>
   
  </div>
</div>
</router-link>


<div style="position:fixed;top:0;left:0;right:0;bottom:0px;background:rgba(0,0,0,0.3);z-index:100000000;cursor:pointer"  class="d-md-block d-none" v-if='opacitybox'  v-on:click='opacitybox=false' ></div>


 


 

 <div class="inputboxui d-md-flex d-none   justify-content-between  " style="background:#fff!important;border:none!important">
  


  <div class="d-flex align-items-center  "   style="cursor:pointer">
  <router-link    to='/bag'   style='text-decoration:none'>
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">1</p>
    </div>
  </router-link>
   </div> 


  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='address' || tab=='paymentmode' "></div>
  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='bag'"></div>



   <div class="d-flex align-items-center  " v-if="tab=='address' || tab=='paymentmode'" style="cursor:pointer"  v-on:click="tab='address'">
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">2</p>
    </div>
   </div> 




   <div class="d-flex align-items-center  " v-if="tab=='bag'">
    <div style="width:40px;height:40px;background: #fff;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#FFB13B;font-weight:700">2</p>
    </div>
   </div> 




    <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='paymentmode'" ></div>
  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='address' || tab=='bag'"></div>



   <div class="d-flex align-items-center  " v-if="tab=='paymentmode'" style="cursor:pointer"   v-on:click="tab='paymentmode'" >
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">3</p>
    </div>
   </div> 



   <div class="d-flex align-items-center  " v-if="tab=='address' || tab=='bag'">
    <div style="width:40px;height:40px;background: #fff;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#FFB13B;font-weight:700;font-weight:700">3</p>
    </div>
   </div> 




 
</div>







<div class="d-flex align-items-center  navwrapper  ml-3   ">
  

  <div class="d-none align-items-center contactwhatsapp" style="">
    
    <img src="https://cdn.usbrandcolors.com/images/logos/whatsapp-logo.svg" style="width:20px;margin-right:6px;min-width:20px;">

 <p style="font-weight:600;color:#fff;font-size:13px">WhatsApp</p>

  </div>
 
  <router-link    to='/bag'   style='text-decoration:none'>
  <div class="d-flex align-items-center navitem pl-4 ml-4" style="position:relative">
    
          <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>


    <div style="width:16px;height:16px;background:#EB3838;border-radius:50%;    position: absolute;
    top: 2px;
    right: 10px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:11px;font-weight:600">{{rendercartlength}}</span>
</div>



 <svg width="17" height="20" viewBox="0 0 17 20" fill="#0B0A23" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.7" d="M15 5.83333H11.6667V3.33333C11.6667 1.4925 10.1742 0 8.33333 0C6.4925 0 5 1.4925 5 3.33333V5.83333H1.66667L0 20H16.6667L15 5.83333ZM5.83333 3.33333C5.83333 1.955 6.955 0.833333 8.33333 0.833333C9.71167 0.833333 10.8333 1.955 10.8333 3.33333V5.83333H5.83333V3.33333ZM5 7.5V8.75C5 8.98 5.18667 9.16667 5.41667 9.16667C5.64667 9.16667 5.83333 8.98 5.83333 8.75V7.5H10.8333V8.75C10.8333 8.98 11.02 9.16667 11.25 9.16667C11.48 9.16667 11.6667 8.98 11.6667 8.75V7.5H13.5183L13.9108 10.8333H2.75667L3.14917 7.5H5Z" fill="#0B0A23"/>
</svg>

 


  </div>
</router-link>

  <div class="d-flex align-items-center    " style="position:relative;padding-left:50px"  >
      
      <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>

      <p class="mya" style="color: #0B0A23;

opacity: 0.8;font-weight: 500;
font-size: 14px;" v-on:click='account'>My Account</p>

<div v-if='user' style="position:absolute;top:0px;left:50%;transform:translateX(-50%);padding-top:40px;cursor:pointer" class="opanav">


  <div style="width:170px;background:#fff;border-radius:4px;box-shadow:0 0 10px rgba(0,0,0,0.1)">

    <router-link to='/whishlist' style='text-decoration:none'>
    <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Wishlist</p>
  </router-link>
   <router-link to='/account' style='text-decoration:none'>
       <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Account</p>
     </router-link>
          <p class="navhover"   v-on:click='logout' style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Logout</p>
  </div>
</div>


  </div>



</div>

</div>

  </div>
  
</div>





 




<!--- header -->



<div v-if='filterbox' style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:10000000000" class="d-flex  filterbox">
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.3);z-index:100000" v-on:click='filterbox=false'></div>
  <div style="" class="actfilterbox">


     <div class="d-flex align-items-center justify-content-between mb-4">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Filter</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='filterbox=false'  ></i>
              </div>

    <template v-for='itm in filters'>
      <div class="d-flex align-items-center my-3" style="cursor:pointer" v-on:click='filterorder(itm)'>
        <div style="width:19px;height:19px;position:relative;border-radius:50px;border:1px solid #00988b">
          <div style="position:absolute;top:3px;right:3px;bottom:3px;left:3px;border-radius:50px;background:#00988b" v-if='itm.selected'></div>
        </div>
        <p style="margin-left:8px;color:#444;font-size:16px">{{itm.name}}</p>
      </div>
    </template>
    
  </div>
</div>

<!-- filters -->
 




 

<div  v-if='loadstatus && theme==3' >

</div>


<div  v-else-if='loadstatus && theme==2' >






 

</div>



<div v-else-if='loadstatus && theme==1' >


 


<div class="pt-md-4 pb-md-5 pt-md-4 pt-0 pb-3  headerwrapper2  d-block   bagmobbg   "  style="min-height: calc(100vh - 200px);">
  <div class="container  pads ">
  <div class="   ">



 
  <div class="container" style="padding:0px;margin:0px; ">
    <div class="row" style="padding:0px;margin:0px; ">
      <div class="col-md-8 mobcontainer" style="padding:0px;padding-right:10px">

         









        <div v-if="tab=='paymentmode'" >
 

        {{paymentmodes}}






<div class="d-flex align-items-center mt-md-5 mb-md-5 mb-3 mt-md-3 mt-0 m17" >
  
  <svg width="21"  v-on:click="tab='address'" height="14" viewBox="0 0 21 14" style='cursor:pointer' fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.363604 6.3636C0.012132 6.71508 0.012132 7.28492 0.363604 7.6364L6.09117 13.364C6.44264 13.7154 7.01249 13.7154 7.36396 13.364C7.71543 13.0125 7.71543 12.4426 7.36396 12.0912L2.27279 7L7.36396 1.90883C7.71543 1.55736 7.71543 0.987511 7.36396 0.636039C7.01249 0.284567 6.44264 0.284567 6.09117 0.636039L0.363604 6.3636ZM1 7.9H21V6.1H1V7.9Z" fill="#0B0A23"/>
</svg>
<p  class="shopbag" style="margin-left:20px;margin-top:0px!important" >Payment
</p>


</div>


 
 <div class="inputboxui  d-md-none d-flex  justify-content-between  " style="background:#fff!important;border:none!important;padding:0px;width:100%;max-width:100%;margin-bottom: 30px;">
  


  <div class="d-flex align-items-center  " v-on:click="tab='bag'" style="cursor:pointer">
     <router-link    to='/bag'   style='text-decoration:none'>
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">1</p>
    </div>
  </router-link>
   </div> 


  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='address' || tab=='paymentmode' "></div>
  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='bag'"></div>



   <div class="d-flex align-items-center  " v-if="tab=='address' || tab=='paymentmode'" style="cursor:pointer"  v-on:click="tab='address'">
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">2</p>
    </div>
   </div> 




   <div class="d-flex align-items-center  " v-if="tab=='bag'">
    <div style="width:40px;height:40px;background: #fff;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#FFB13B;font-weight:700">2</p>
    </div>
   </div> 




    <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='paymentmode'" ></div>
  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='address' || tab=='bag'"></div>



   <div class="d-flex align-items-center  " v-if="tab=='paymentmode'" style="cursor:pointer"   v-on:click="tab='paymentmode'" >
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">3</p>
    </div>
   </div> 



   <div class="d-flex align-items-center  " v-if="tab=='address' || tab=='bag'">
    <div style="width:40px;height:40px;background: #fff;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#FFB13B;font-weight:700;font-weight:700">3</p>
    </div>
   </div> 




 
</div>






<div class="container mb-2 conformob"   style=" border-radius:0px;padding:0px ;" >
  <div class="row" style="padding:0px;margin:0px">
    <div class="col-md-12  " style="padding:0px;margin:0px; ">


 <div class="paybtns"   v-on:click="paymenttab='cash'" v-if= "info.paymentmethods.includes('COD')">

 
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              
                            <div v-if="paymenttab=='cash'"   style="width:22px;height:22px;border-radius:30px;border:1px solid rgb(246 74 84 / 90%);margin-right: 10px;" class="d-flex align-items-center justify-content-center">
                              <div style="width:14px;height:14px;border-radius:30px;background:rgba(246, 74, 84, 0.6)"></div>
                            </div>

                              <div v-else style="width:22px;height:22px;border-radius:30px;border:1px solid rgba(166, 166, 192, 0.6);background:background:rgba(255,255,255,0.6);margin-right: 10px;" class="d-flex align-items-center justify-content-center">
                             
                            </div>

                            <p style="" class="codtext">Cash on Delivery</p>


            </div>

            <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 7C12.344 7 11 8.344 11 10C11 11.656 12.344 13 14 13C15.656 13 17 11.656 17 10C17 8.344 15.656 7 14 7ZM14.15 11.484V11.799H13.85V11.5C13.539 11.495 13.218 11.421 12.951 11.283L13.086 10.79C13.373 10.9 13.755 11.019 14.054 10.952C14.399 10.874 14.469 10.519 14.088 10.348C13.809 10.219 12.955 10.106 12.955 9.375C12.955 8.966 13.268 8.6 13.85 8.52V8.201H14.151V8.506C14.368 8.512 14.612 8.549 14.883 8.632L14.775 9.125C14.545 9.045 14.29 8.971 14.042 8.986C13.596 9.012 13.556 9.399 13.868 9.561C14.382 9.803 15.05 9.981 15.05 10.624C15.051 11.14 14.647 11.415 14.15 11.484ZM4 4V16H24V4H4ZM22 14H6V6H22V14ZM21 2H2V13H0V0H21V2Z" fill="rgba(11, 10, 35, 0.6)"/>
</svg>

            
          </div>





     
        </div>





 <div class="paybtns"  style="opacity:0.5" v-if= "!info.paymentmethods.includes('COD')">

 
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              
                            <div v-if="paymenttab=='cash'"   style="width:22px;height:22px;border-radius:30px;border:1px solid rgb(246 74 84 / 90%);margin-right: 10px;" class="d-flex align-items-center justify-content-center">
                              <div style="width:14px;height:14px;border-radius:30px;background:rgba(246, 74, 84, 0.6)"></div>
                            </div>

                              <div v-else style="width:22px;height:22px;border-radius:30px;border:1px solid rgba(166, 166, 192, 0.6);background:background:rgba(255,255,255,0.6);margin-right: 10px;" class="d-flex align-items-center justify-content-center">
                             
                            </div>

                            <p style="" class="codtext">Cash on Delivery</p>


            </div>

            <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14 7C12.344 7 11 8.344 11 10C11 11.656 12.344 13 14 13C15.656 13 17 11.656 17 10C17 8.344 15.656 7 14 7ZM14.15 11.484V11.799H13.85V11.5C13.539 11.495 13.218 11.421 12.951 11.283L13.086 10.79C13.373 10.9 13.755 11.019 14.054 10.952C14.399 10.874 14.469 10.519 14.088 10.348C13.809 10.219 12.955 10.106 12.955 9.375C12.955 8.966 13.268 8.6 13.85 8.52V8.201H14.151V8.506C14.368 8.512 14.612 8.549 14.883 8.632L14.775 9.125C14.545 9.045 14.29 8.971 14.042 8.986C13.596 9.012 13.556 9.399 13.868 9.561C14.382 9.803 15.05 9.981 15.05 10.624C15.051 11.14 14.647 11.415 14.15 11.484ZM4 4V16H24V4H4ZM22 14H6V6H22V14ZM21 2H2V13H0V0H21V2Z" fill="rgba(11, 10, 35, 0.6)"/>
</svg>

            
          </div>





     
        </div>






<div  class="d-md-block d-none"  style="padding: 0px 8px;" v-if='info.paymentmethods.length==2'><div   style="opacity: 0.5; border-bottom: 1px solid rgb(231, 231, 247);"></div></div>


            <div style=""   v-on:click="paymenttab='online'" v-if="   info.paymentmethods.includes('ONLINE')" class="paybtns">
 

       

          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              
                            <div v-if="paymenttab=='online'"   style="width:22px;height:22px;border-radius:30px;border:1px solid rgb(246 74 84 / 90%);margin-right: 10px;" class="d-flex align-items-center justify-content-center">
                              <div style="width:14px;height:14px;border-radius:30px;background:rgba(246, 74, 84, 0.6)"></div>
                            </div>

                              <div v-else style="width:22px;height:22px;border-radius:30px;border:1px solid rgba(166, 166, 192, 0.6);background:background:rgba(255,255,255,0.6);margin-right: 10px;" class="d-flex align-items-center justify-content-center">
                             
                            </div>

                            <p style=" " class="codtext">Online Payment</p>


            </div>

       <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 0H2C0.896 0 0 0.896 0 2V14C0 15.104 0.896 16 2 16H22C23.104 16 24 15.104 24 14V2C24 0.896 23.104 0 22 0ZM3 5.78C3 5.349 3.349 5 3.78 5H4.208V6.125H3V5.78ZM3 6.544H4.208V7.512H3V6.544ZM3 7.932H4.208V9H3.78C3.349 9 3 8.651 3 8.22V7.932ZM6 13H3V12H6V13ZM7 8.22C7 8.651 6.651 9 6.22 9H5.791V7.932H7V8.22ZM7 7.512H5.791V6.544H7V7.512ZM7 6.125H5.371V9H4.628V5H6.22C6.651 5 7 5.349 7 5.78V6.125ZM11 13H8V12H11V13ZM12 6.5C12 5.119 13.119 4 14.5 4C14.984 4 15.437 4.138 15.82 4.377C15.289 4.929 14.963 5.677 14.963 6.5C14.963 7.324 15.29 8.071 15.82 8.623C15.437 8.862 14.984 9 14.5 9C13.119 9 12 7.881 12 6.5ZM16 13H13V12H16V13ZM21 13H18V12H21V13ZM18.5 9C17.12 9 16 7.881 16 6.5C16 5.119 17.12 4 18.5 4C19.881 4 21 5.119 21 6.5C21 7.881 19.881 9 18.5 9Z" fill="rgba(11, 10, 35, 0.6)"/>
</svg>


            
          </div>



 
        </div>






      <div class="d-none">






          <div class='mb-2'  v-if="info.paymentmethods.includes('COD')">
              <div   v-on:click="paymenttab='cash'" v-if="paymenttab=='cash'" class="d-flex align-items-center px-4 py-4 mt-2  " style="background:#fff;cursor:pointer;
 
    color: #146eb4;    border-bottom: 1px solid #e5e5e5;"  >



    <div style="flex:1" class="d-flex align-items-center">
      

        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="mr8"><g fill="none" fill-rule="evenodd"><g fill="#1A181E" fill-rule="nonzero"><g><path d="M19.943 3.6c.347 0 .631.295.631.659v2.105h1.957c.347 0 .63.296.63.66v12.318c0 .362-.283.657-.63.657H4.418c-.346 0-.63-.295-.63-.657v-2.108l-1.957.002c-.347 0-.631-.296-.631-.66V4.26c0-.364.284-.659.631-.659zm.631 4.081v8.896c0 .363-.284.659-.631.659l-14.895-.002v1.449H21.9v-11l-1.326-.002zm-1.261-2.763H2.46v11l1.947-.001 14.905.001v-11zm-5.366 1.287c.319 0 .578.232.578.516 0 .284-.259.516-.578.516l-1.55-.001.013.015c.237.286.41.616.499.966l.01.047h1.028c.291 0 .534.195.572.447l.006.07c0 .284-.259.515-.578.515h-1.025l-.037.145c-.316 1.077-1.384 1.874-2.655 1.934l-.153.003h-.101l2.827 2.388c.205.178.234.456.078.664l-.057.067c-.221.206-.586.215-.816.02l-3.882-3.28c-.107-.098-.173-.23-.173-.363-.006-.287.252-.522.577-.528h1.548c.75-.001 1.4-.427 1.645-1.035l.004-.015h-3.2c-.291 0-.533-.194-.57-.446l-.007-.07c0-.284.26-.516.578-.516h3.198c-.233-.566-.824-.977-1.515-1.022l-.132-.005H8.528c-.318 0-.578-.232-.578-.516 0-.284.26-.516.578-.516z" transform="translate(-116 -180) translate(116 180)"></path></g></g></g></svg>

           <p style="margin-left:15px;font-size:16px;font-weight:500;margin-bottom:0px">Cash on Delivery</p>
                </div>


     <div  style="width:20px;min-width:20px;height:20px;border-radius:40px;background;border:1px solid #216eb4;margin-right:15px;position:relative">
                                  <div style="position:absolute;top:4px;right:4px;bottom:4px;left:4px;border-radius:50%;background:#216eb4"></div>
                             
                           </div>


          </div>

              <div v-else v-on:click="paymenttab='cash'" class="d-flex align-items-center px-4 py-4   mt-2" style="cursor:pointer;    border-bottom: 1px solid #e5e5e5;background:#fff" >




                 <div style="flex:1" class="d-flex align-items-center">
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="mr8"><g fill="none" fill-rule="evenodd"><g fill="#1A181E" fill-rule="nonzero"><g><path d="M19.943 3.6c.347 0 .631.295.631.659v2.105h1.957c.347 0 .63.296.63.66v12.318c0 .362-.283.657-.63.657H4.418c-.346 0-.63-.295-.63-.657v-2.108l-1.957.002c-.347 0-.631-.296-.631-.66V4.26c0-.364.284-.659.631-.659zm.631 4.081v8.896c0 .363-.284.659-.631.659l-14.895-.002v1.449H21.9v-11l-1.326-.002zm-1.261-2.763H2.46v11l1.947-.001 14.905.001v-11zm-5.366 1.287c.319 0 .578.232.578.516 0 .284-.259.516-.578.516l-1.55-.001.013.015c.237.286.41.616.499.966l.01.047h1.028c.291 0 .534.195.572.447l.006.07c0 .284-.259.515-.578.515h-1.025l-.037.145c-.316 1.077-1.384 1.874-2.655 1.934l-.153.003h-.101l2.827 2.388c.205.178.234.456.078.664l-.057.067c-.221.206-.586.215-.816.02l-3.882-3.28c-.107-.098-.173-.23-.173-.363-.006-.287.252-.522.577-.528h1.548c.75-.001 1.4-.427 1.645-1.035l.004-.015h-3.2c-.291 0-.533-.194-.57-.446l-.007-.07c0-.284.26-.516.578-.516h3.198c-.233-.566-.824-.977-1.515-1.022l-.132-.005H8.528c-.318 0-.578-.232-.578-.516 0-.284.26-.516.578-.516z" transform="translate(-116 -180) translate(116 180)"></path></g></g></g></svg>

           <p style="margin-left:15px;font-size:16px;font-weight:500;margin-bottom:0px">Cash on Delivery</p>
         </div>
              <div style="width:20px;min-width:20px;height:20px;border-radius:40px;background;border:1px solid #b3b3b3;margin-right:15px;position:relative">
                              
                           </div>
          </div>


          </div>




  <div class='mb-md-0 mb-2'  v-if="info.paymentmethods.includes('ONLINE')">

              <div   v-on:click="paymenttab='online'" v-if="paymenttab=='online'" class="d-flex align-items-center px-4 py-4  mt-2borbot  " style="background:#fff;cursor:pointer;
 
    color: #146eb4;  " >


            <div style="flex:1" class="d-flex align-items-center">
              
   

            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="mr8"><g fill="none" fill-rule="evenodd"><g fill="#1A181E" fill-rule="nonzero"><g><g><g><path d="M19.238 0C20.54 0 21.6 1.145 21.6 2.553v10.944c0 1.408-1.06 2.553-2.363 2.553H2.364C1.06 16.05 0 14.905 0 13.497V2.553C0 1.145 1.06 0 2.362 0zm1.012 5.472H1.35v8.025c0 .603.454 1.094 1.012 1.094h16.875c.559 0 1.013-.491 1.013-1.094V5.472zM4.725 10.214c.373 0 .675.326.675.73v.729c0 .403-.302.73-.675.73H4.05c-.373 0-.675-.327-.675-.73v-.73c0-.403.302-.73.675-.73h.675zm14.513-8.755H2.363c-.559 0-1.013.491-1.013 1.094v1.46h18.9v-1.46c0-.603-.454-1.094-1.012-1.094z" transform="translate(-116 -244) translate(116 180) translate(0 64) translate(1.2 3.975)"></path></g></g></g></g></g></svg>
           <p style="margin-left:15px;font-size:16px;font-weight:500;margin-bottom:0px">Online Payment</p>
                    </div>

                        <div  style="width:20px;min-width:20px;height:20px;border-radius:40px;background;border:1px solid #216eb4;margin-right:15px;position:relative">
                                  <div style="position:absolute;top:4px;right:4px;bottom:4px;left:4px;border-radius:50%;background:#216eb4"></div>
                             
                           </div>
          </div>

              <div v-else v-on:click="paymenttab='online'" class="d-flex align-items-center px-4 py-4  mt-2 " style="cursor:pointer;    border-bottom: 1px solid #e5e5e5;background:#fff" >
 

                            <div style="flex:1" class="d-flex align-items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="mr8"><g fill="none" fill-rule="evenodd"><g fill="#1A181E" fill-rule="nonzero"><g><g><g><path d="M19.238 0C20.54 0 21.6 1.145 21.6 2.553v10.944c0 1.408-1.06 2.553-2.363 2.553H2.364C1.06 16.05 0 14.905 0 13.497V2.553C0 1.145 1.06 0 2.362 0zm1.012 5.472H1.35v8.025c0 .603.454 1.094 1.012 1.094h16.875c.559 0 1.013-.491 1.013-1.094V5.472zM4.725 10.214c.373 0 .675.326.675.73v.729c0 .403-.302.73-.675.73H4.05c-.373 0-.675-.327-.675-.73v-.73c0-.403.302-.73.675-.73h.675zm14.513-8.755H2.363c-.559 0-1.013.491-1.013 1.094v1.46h18.9v-1.46c0-.603-.454-1.094-1.012-1.094z" transform="translate(-116 -244) translate(116 180) translate(0 64) translate(1.2 3.975)"></path></g></g></g></g></g></svg>
           <p style="margin-left:15px;font-size:16px;font-weight:500;margin-bottom:0px">Online Payment</p>
         </div>
           <div style="width:20px;min-width:20px;height:20px;border-radius:40px;background;border:1px solid #b3b3b3;margin-right:15px;position:relative">
                              
                           </div>
          </div>


          </div>




 
 

      </div>
    </div>
    

  </div>
</div>
 

                </div>








    


        <div v-if="tab=='address'">
          




<div class=" d-none  justify-content-between  mb-md-4 mb-3 mt-md-3 mt-0  ">
  
  <p class="categorytextcat  "   >Select a delivery address</p>
 
</div> 




<div class="d-flex align-items-center mt-md-5 mb-md-5 mb-3 mt-md-3 mt-0 m17" >
   <router-link   to='/bag'  style='text-decoration:none'>
  <svg width="21"   height="14" viewBox="0 0 21 14" style='cursor:pointer' fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.363604 6.3636C0.012132 6.71508 0.012132 7.28492 0.363604 7.6364L6.09117 13.364C6.44264 13.7154 7.01249 13.7154 7.36396 13.364C7.71543 13.0125 7.71543 12.4426 7.36396 12.0912L2.27279 7L7.36396 1.90883C7.71543 1.55736 7.71543 0.987511 7.36396 0.636039C7.01249 0.284567 6.44264 0.284567 6.09117 0.636039L0.363604 6.3636ZM1 7.9H21V6.1H1V7.9Z" fill="#0B0A23"/>
</svg>
</router-link>
<p  class="shopbag" style="margin-left:20px;margin-top:0px!important" >Select Address
</p>


</div>


 
 <div class="inputboxui  d-md-none d-flex  justify-content-between  " style="background:#fff!important;border:none!important;padding:0px;width:100%;max-width:100%;margin-bottom: 15px;">
  


  <div class="d-flex align-items-center  "   style="cursor:pointer">
     <router-link  to='/bag'  style='text-decoration:none'>
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">1</p>
    </div>
  </router-link>
   </div> 


  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='address' || tab=='paymentmode' "></div>
  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='bag'"></div>



   <div class="d-flex align-items-center  " v-if="tab=='address' || tab=='paymentmode'" style="cursor:pointer"  v-on:click="tab='address'">
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">2</p>
    </div>
   </div> 




   <div class="d-flex align-items-center  " v-if="tab=='bag'">
    <div style="width:40px;height:40px;background: #fff;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#FFB13B;font-weight:700">2</p>
    </div>
   </div> 




    <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='paymentmode'" ></div>
  <div style="flex:1;height:2px;background:#FFB13B"  v-if="tab=='address' || tab=='bag'"></div>



   <div class="d-flex align-items-center  " v-if="tab=='paymentmode'" style="cursor:pointer"   v-on:click="tab='paymentmode'" >
    <div style="width:40px;height:40px;background: #FFB13B;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#fff;font-weight:700;font-weight:700">3</p>
    </div>
   </div> 



   <div class="d-flex align-items-center  " v-if="tab=='address' || tab=='bag'">
    <div style="width:40px;height:40px;background: #fff;
border: 1px solid #FFB13B;;border-radius:50%" class="d-flex align-items-center justify-content-center">
      <p style="color:#FFB13B;font-weight:700;font-weight:700">3</p>
    </div>
   </div> 




 
</div>


 


 <div style="" class="cartborder" >

<div class="   d-md-flex d-none  justify-content-between paditemslen  " style=" ">
  
  <p class="categorytextcat   itemslength" style=""  >{{rendercartlength}} Items</p>
  <p class="categorytextcat  "  style="font-family: 'Montserrat', sans-serif;font-size:14px;font-weight:700" ><span style="" class="totaltext">Total: </span> <span  class="totalvals"> ₹ {{totalvalues}}</span></p>
 
</div>






<div class="container" style="padding:0px;margin:0px">
  <div class="row cartpad3 mt-md-0 mt-3" style="">
    


                  <template v-for='(itm,index) in address'>
                    
 
                  <div v-if='!(index % 2 == 0)' class="col-md-6 mb-md-4 mb-3" style="padding:0px;margin:0px"  >
 
 
                    <div style="padding-left:13px;"  class="padlr">

                      <div style="border:1px solid rgba(231, 231, 247, 0.5);border-radius:5px;padding:20px;cursor:pointer;display:flex;align-items-start;background:rgb(239 239 245 / 45%)"  v-on:click='selectaddress(itm)'> 
                            
                          
     
                            <div v-if='itm.selected' style="width:22px;height:22px;border-radius:30px;border:1px solid rgb(246 74 84 / 90%);margin-top: 2px;" class="d-flex align-items-center justify-content-center">
                              <div style="width:14px;height:14px;border-radius:30px;background:rgba(246, 74, 84, 0.6)"></div>
                            </div>

                              <div v-else style="width:22px;height:22px;border-radius:30px;border:1px solid rgba(166, 166, 192, 0.6);background:background:rgba(255,255,255,0.6);margin-top: 2px;" class="d-flex align-items-center justify-content-center">
                             
                            </div>
                            
                            <div style="flex:1;padding-left:13px">
                              
                      
                           <p style="" class="addrname1">{{itm.name}}</p>

                            <p style=" " class="addrmobile1">Mobile:  {{itm.mobile}} </p>
                            <p style="" class="addraddr1">{{itm.address}}</p>
                            <p style="" class="addrcity1">{{itm.city}} . {{itm.pincode}}</p>



 <div class="d-flex align-items-center mt-md-3 mt-2">
                                <p style="" class="edit1" v-on:click='editaddress(itm)'>Edit</p>
                              <p style="
" class="del1" v-on:click='deleteaddress(itm)'>Delete</p>
                            </div>


 
                                  </div>


                      </div>
                        
                    </div>
              
                  </div>

                  <div v-else class="col-md-6 mb-md-4 mb-3" style="padding:0px;margin:0px"  >
                     <div style="padding-right:10px;" class="padlr" >

                      <div style="border:1px solid rgba(231, 231, 247, 0.5);border-radius:5px;padding:20px;cursor:pointer;font-family: 'Montserrat', sans-serif;display:flex;align-items-start;background:rgb(239 239 245 / 45%)"   v-on:click='selectaddress(itm)'> 
                              





     
                            <div v-if='itm.selected' style="width:22px;height:22px;border-radius:30px;border:1px solid rgb(246 74 84 / 90%);margin-top: 2px;" class="d-flex align-items-center justify-content-center">
                              <div style="width:14px;height:14px;border-radius:30px;background:rgba(246, 74, 84, 0.6)"></div>
                            </div>

                              <div v-else style="width:22px;height:22px;border-radius:30px;border:1px solid rgba(166, 166, 192, 0.6);background:rgba(255,255,255,0.6);margin-top: 2px;" class="d-flex align-items-center justify-content-center">
                             
                            </div>
                            
                            <div style="flex:1;padding-left:13px">
                                    <p style="" class="addrname1">{{itm.name}}</p>

                            <p style=" " class="addrmobile1">Mobile:  {{itm.mobile}} </p>
                            <p style="" class="addraddr1">{{itm.address}}</p>
                            <p style="" class="addrcity1">{{itm.city}} . {{itm.pincode}}</p>
                            <div class="d-flex align-items-center   mt-md-3 mt-2">
                                <p style="" class="edit1" v-on:click='editaddress(itm)'>Edit</p>
                              <p style="
" class="del1" v-on:click='deleteaddress(itm)'>Delete</p>
                            </div>
                                  </div>
                             
                          


                      </div>
                        
                    </div>
              
                  </div>

                               </template>


                     


                      <div  v-if='!(address.length % 2 == 0)'     class="col-md-12 mb-4 mt-2   " style="padding:0px;margin:0px;margin-bottom: 136px!important;"  >
                     <div style="padding-left:0px;height:100%">

                      <div style="border:1px solid #EB3838;border-radius:5px;padding:13px;cursor:pointer;font-family: 'Montserrat', sans-serif;height:100%" class="d-flex align-items-center justify-content-center " v-on:click='addressbox '> 
                              
                            
                           
                            <div class="d-flex align-items-center justify-content-center " v>
                           
                             <p style="font-weight: 600;
font-size: 16px;
 

text-align: center;

color: #EB3838;" >Add Address</p>
                            </div>

                             
                          


                      </div>
                        
                    </div>
              
                  </div>
                    <div  v-else     class="col-md-12 mb-4 mt-2   " style="padding:0px;margin:0px;margin-bottom: 136px!important;"  >
                     <div style="padding-right:0px;height:100%">

                      <div style="border:1px solid #EB3838;border-radius:5px;padding:13px;cursor:pointer;font-family: 'Montserrat', sans-serif;height:100%" class="d-flex align-items-center justify-content-center " v-on:click='addressbox'> 
                              
                            
                           
                            <div class="d-flex align-items-center justify-content-center ">
                         
                             <p style="font-weight: 600;
font-size: 16px;
 

text-align: center;

color: #EB3838;" >Add Address</p>
                            </div>

                             
                          


                      </div>
                        
                    </div>
              
                  </div>

  </div>
</div>

</div>




                </div>


      </div>






 






       <div class="col-md-4 mobcontainer d-md-block d-none" style="padding:0px;padding-left:10px">
        <div class="   rightcashbox " >
              <div  v-if="!rendercoupondatas.confirmedcoupon  "class="d-flex align-items-center justify-content-between py-3 px-4 mb-md-0 mb-2 applyborder " style="">
                <div class="d-flex align-items-center">

                  <div style="width:34px;height:34px;border-radius:34px;border:1px solid #FFB13B" class="d-flex align-items-center justify-content-center">
                    <p style="font-weight: 800;
font-size: 16px;
  


color: #FFB13B;">%</p>
                  </div>
              


                     <p style="" class="applyc">Apply coupon</p>
                </div>
                <div v-on:click='apply=true' class="applybtns" style=" 
">
                  Apply
                </div>
             
              </div>





                <div class="d-flex align-items-center justify-content-between py-3 px-4  mb-md-0 mb-2" v-if="rendercoupondatas.confirmedcoupon && tab=='bag' " style="border-bottom:1px solid #e5e5e5;background:#fff">
                  <div>
                    
                  
                <div class="d-flex align-items-center">
                 
                    
                  
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" class="mr6" color=""><path fill="#ee741f" fill-rule="nonzero" d="M13.575.022a.727.727 0 01.685.184l1.788 1.745a.632.632 0 00.266.154l2.406.676a.725.725 0 01.5.5l.676 2.405c.028.1.082.194.155.269l1.744 1.788c.176.18.245.437.183.68l-.617 2.421a.634.634 0 000 .312l.617 2.42a.719.719 0 01-.183.681l-1.744 1.788a.628.628 0 00-.155.269l-.676 2.405a.725.725 0 01-.5.5l-2.405.676a.625.625 0 00-.267.154l-1.789 1.745a.725.725 0 01-.684.184l-2.422-.618a.634.634 0 00-.306 0l-2.422.618a.725.725 0 01-.684-.184L5.95 20.05a.618.618 0 00-.265-.154l-2.406-.677a.722.722 0 01-.5-.499l-.676-2.405a.634.634 0 00-.155-.269L.205 14.257a.72.72 0 01-.183-.68l.617-2.421a.658.658 0 000-.312l-.617-2.42a.721.721 0 01.183-.681l1.744-1.788a.634.634 0 00.155-.269l.676-2.405a.725.725 0 01.5-.5l2.406-.676a.626.626 0 00.266-.154L7.74.206a.725.725 0 01.684-.184l2.422.617c.08.02.164.025.21.019l.096-.019zm-.037 1.498l-2.063.525-.167.033c-.272.04-.551.027-.818-.04L8.46 1.52 6.963 2.982a2.062 2.062 0 01-.689.445l-.196.066-2.016.566-.566 2.016a2.059 2.059 0 01-.374.73l-.136.155-1.464 1.5.518 2.03c.068.268.082.547.041.82l-.041.202-.517 2.029 1.463 1.5c.193.198.344.433.445.689l.065.195.566 2.015 2.016.568c.266.074.515.202.73.374l.155.137L8.46 20.48l2.028-.516c.268-.069.548-.082.82-.041l.203.04 2.028.517 1.498-1.461a2.08 2.08 0 01.69-.446l.195-.065 2.014-.568.568-2.015c.075-.266.202-.514.374-.73l.136-.155 1.461-1.5-.515-2.028a2.075 2.075 0 01-.041-.819l.04-.203.517-2.03-1.462-1.499a2.065 2.065 0 01-.444-.688l-.066-.196-.568-2.017-2.014-.566a2.084 2.084 0 01-.73-.374l-.155-.137-1.499-1.462zm.034 11.034a2.163 2.163 0 010 4.324 2.162 2.162 0 010-4.324zm.114-5.06a.704.704 0 11.996.998l-6.854 6.865a.701.701 0 01-.996 0 .706.706 0 010-.997zm-.114 6.47a.752.752 0 000 1.504.752.752 0 00.001-1.504zm-5.63-7.99a2.162 2.162 0 01-.001 4.324 2.162 2.162 0 010-4.325zm0 1.41a.752.752 0 00-.001 1.504.752.752 0 000-1.504z"></path></svg>
                     <p style="color:#ee741f;font-size:14px;margin-left:6px;">{{rendercoupondatas.confirmedcouponcode}}</p>

                     </div>
                        <p style="color:#808080;font-size:12px;font-weight:200 " class="mt-2">Coupon code successfully applied!</p>
                   </div>
                <i class='bx bxs-x-circle'   v-on:click='removecoupon'style="font-size:20px;color:#E6E6E6;cursor:pointer" ></i>
                
              </div>




              <div class="p-4 marb"  style="background:#fff;">
                      <div class="d-flex justify-content-between">
      <span  class="itmtxt itmtotaltxt" style="
">Item Total</span>
      <span class="itmtxt itmtxt1 " style="" id="itmtot">₹{{totalitemvalues}}</span>
    </div>



 <div class="d-flex justify-content-between mt-2 " v-if='rendercoupondatas.confirmedcoupon'>
      <span  class="itmtxt" style="font-size:14px!important">Discount ({{rendercoupondatas.confirmedcouponcode}})</span>
       <span class="itmtxt" style="font-size:14px!important;color:#17b31b" id="itmtot">-₹{{rendercoupondatas.discountamount}}</span>





    </div>

 <div class="d-flex justify-content-between mt-3 ">
          <span  class="itmtxt deltxt" style="
">Delivery Fee</span>

      <span class="itmtxt" style="font-size:17px!important;color:#17b31b;font-family: 'Nunito', sans-serif;font-weight:700" v-if="renderdelivery=='Free'" id="delcharge" data-delcharge=39>{{renderdelivery}}</span>
       <span class="itmtxt" style="font-size:17px!important; font-family: 'Nunito', sans-serif;font-weight:700" v-else id="delcharge" data-delcharge=39>{{renderdelivery}}</span>




    </div>
     <p class="itmtxt mt-2" style="font-family: 'Roboto', sans-serif!important;font-size:14px!important;color:#808080; " v-if="renderdelivery!='Free'" id="delcharge" data-delcharge=39>Free delivery above       <span class="itmtotal" style="font-size:15px;font-weight:400;margin-left:4px;    font-family: 'Montserrat', sans-serif;text-transform: none;">₹{{info.freedeliveryabove}}</span></p>




    <div style="border-top: 1px solid #D9D7EA;margin-top:30px;margin-bottom:10px" ></div>



 
     <div class="d-flex justify-content-between    padtop15 "  >
      <span class="itmtotal totaltextsx" style="">Total</span>
      <span  class="itmtotal" style="font-weight: 600;
font-size: 18px; 

text-align: right;

color: #0B0A23;"  id="totalpay">₹{{totalvalues}}</span>
    </div>
 
 



<div  class="mt-3 d-md-none d-block">

 
              <div v-if='rendercoupondatas.confirmedcoupon' style="padding:7px 0px;border-radius:4px;background:#E7F7E8;color:#55B72D;margin-bottom:15px">
                <p   style="font-weight:400;font-size:15px;text-align:center"  ><span style="font-family: 'Montserrat', sans-serif;">₹{{rendercoupondatas.discountamount}}</span> saved so far!</p>
                <p   v-if="renderdelivery!='Free'"  style="font-weight:400;font-size:12px;text-align:center"   class="mt-1" >Save <span style="font-family: 'Montserrat', sans-serif;">₹{{info.deliveryamount}}</span> on delivery fee. Add <span style="font-family: 'Montserrat', sans-serif;">₹ {{renderabovevalue}}</span> more to bag</p>
              </div>
</div>




              </div>

<div style="padding:0px 20px" class="d-md-block d-none">

 
              <div v-if='rendercoupondatas.confirmedcoupon' style="padding:7px 0px;border-radius:4px;background:#E7F7E8;color:#55B72D;margin-bottom:15px">
                <p   style="font-weight:400;font-size:15px;text-align:center"  ><span style="font-family: 'Montserrat', sans-serif;">₹{{rendercoupondatas.discountamount}}</span> saved so far!</p>
                <p   v-if="renderdelivery!='Free'"  style="font-weight:400;font-size:12px;text-align:center"   class="mt-1" >Save <span style="font-family: 'Montserrat', sans-serif;">₹{{info.deliveryamount}}</span> on delivery fee. Add <span style="font-family: 'Montserrat', sans-serif;">₹ {{renderabovevalue}}</span> more to bag</p>
              </div>
</div>
<div style="padding:9px 20px;margin-bottom:30px " class="d-md-block d-none" v-if="tab=='bag' || tab=='address'  || tab=='paymentmode' " >


  <div v-if="tab=='bag'" style="background:#EB3838;text-align:center;padding:10px;border-radius:5px;color:#fff;font-size:18px;cursor:pointer;font-size: 16px;
font-weight:700;

color: #FFFFFF;" v-on:click="tab='address'">
  Select Address
</div>

<div v-if="tab=='address'" style="background:#EB3838;text-align:center;padding:10px;border-radius:5px;color:#fff;font-size:18px;cursor:pointer;font-size: 16px;
font-weight:700;

color: #FFFFFF;" v-on:click="tab='paymentmode'">
Continue
</div>



<div v-if="tab=='paymentmode' && paymenttab=='cash'"    v-on:click='placeorder'  style="background:#EB3838;text-align:center;padding:10px;border-radius:5px;color:#fff;font-size:18px;cursor:pointer;font-size: 16px;
font-weight:700;

color: #FFFFFF;"  >
Place Order
</div>


<div  v-if="tab=='paymentmode' && paymenttab=='online'"  >
  <div v-if='!payloader'  v-on:click='placeorder'    style="background:#EB3838;text-align:center;padding:10px;border-radius:5px;color:#fff;font-size:18px;cursor:pointer;font-size: 16px;
font-weight:700;

color: #FFFFFF;"  >
Pay ₹{{totalvalues}}
</div>
   <div v-else  style="background:#EB3838;text-align:center;padding:0px;border-radius:5px;color:#fff;font-size:18px;cursor:pointer;font-size: 16px;
font-weight:700;

color: #FFFFFF;"   >
 
<img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" style="height:50px">
</div>

</div>




 

</div>






<div style="padding:13px 14px;;position:fixed;bottom:54px;left:0;right:0;background: #F6F6FA;
border-radius: 3px;" class="d-md-none d-flex justify-content-between"  >

  <div class="mr-5">
          <p  class="itmtotal" style="font-family: 'Nunito', sans-serif;font-weight:700;font-size:17px;color:#0B0A23"  id="totalpay">₹ {{totalvalues}}</p>
          <p style="color:#EB3838;font-size:14px;font-weight:700">View price details</p>

  </div>

  <router-link to="/address" style='text-decoration:none'>
  <div  style="background:#EB3838;font-size:13px;font-weight:700;text-align:center;border-radius:5px;color:#fff; cursor:pointer;padding:12px 20px;flex:1"  >
  Select address
</div>
</router-link>
 

</div>





        </div>
      </div>





    </div>
  </div>


 
 




 


 </div>

  </div>
  
</div>
 



 


 
  </div>
 


 

<div  v-else >



    <div  style="height:calc(100vh - 94px);background:#fff; " class="d-md-flex d-none align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" class="img-fluid" style="width:100%">
   </div>
 </div>




    <div  style="height:calc(100vh - 54px);background:#fff; " class="d-md-none d-flex align-items-center justify-content-center">
   
   <div style="width:80px;">
     <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" class="img-fluid" style="width:100%">
   </div>
 </div>





 

      </div>





 


 










  



<!--footer -->

   

 <div style="background: #262626;" class="p-5 mt-5 mb-md-0 mb-5">
   
   <div class="container py-5 mb-md-0 mb-5">
     <div class="row justify-content-center">



      
       <div class="col-md-4"  >
         <div>
             
 


 <div style="margin-left:-8px">
       <img  src="./images/finallogo.png" class="img-fluid" style="position:relative;height:40px" >

 </div>
<p style="font-weight: 400;font-size: 15px;margin:15px 0px;color: #FFFFFF;line-height: 26px;font-weight:600;display:none">SAYRA APPARELS PVT LTD</p>
 
 <h2 style="color:#fff;font-weight:600;font-size:18px;margin-top:22px">Get in Touch</h2>
<p style="color:#fff; opacity:0.7;font-weight:500;padding-right:80px;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Monday - Saturday</p>
<p style="color:#fff; opacity:0.7;font-weight:500;padding-right:80px;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">9:00 AM to 6:00 PM</p>
<a href="tel:+918433408665" style="text-decoration:none;color:#fff; opacity:0.7;font-weight:500;padding-right:80px;display:block;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">+91 8433408665</a>
<a href="mailto:support@sayra.in" style="text-decoration:none;color:#fff; opacity:0.7;font-weight:500;padding-right:80px;display:block;margin-bottom:5px;color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">support@sayra.in</a>
<div class="d-none align-items-center   mt-4">
  <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;margin-right:13px;min-width:30px;background:#fff;margin-left:0px">
      <i class='bx bxl-facebook' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-instagram' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-youtube' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-twitter' style="color:#1B1A31;font-size:20px"></i>
  </div>
</div>

         </div>
       </div>


       <div class="col-md-4 mt-md-0 mt-4">
         <div>
           <h2 style="color:#fff;font-weight:600;font-size:18px">Customer Help</h2>
           <div>
             <router-link  to='/termsconditions' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Terms & Condition</router-link>


              <router-link   to='/privacypolicy'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Privacy Policy</router-link>
               <router-link   to='/refundpolicy'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Refund Policy</router-link>
                <router-link  to='/shipping'   style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Shipping Policy</router-link>
              <router-link  to='/returnexchange'  style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Return & Exchange</router-link>

                       <router-link to="/about"    style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">About Us</router-link>
           </div>
         </div>
       </div>
      
       <div class="col-md-4  mt-md-0 mt-4">
         <div>
           <h2 style="color:#fff;font-weight:600;font-size:18px">My Account</h2>
           <div>
             <router-link to='/bag' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">View Cart</router-link>

              <a href="https://tracklite.in/c/sayraindia" style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Track My Order</a>

               <router-link to='/contact' style="color:#fff;opacity:0.4;font-size:17px;font-weight:400;margin-bottom:6px;display:block;text-decoration:none">Contact Us</router-link>
            </div>
         </div>
       </div>
           


           
         </div>




       </div>

     </div>
 

 <div style="background: #1B1A31;" class=" d-none p-5 mt-5">
   
   <div class="container py-5">
     <div class="row justify-content-center">
       <div class="col-md-4" style="text-align:center">
         <div>
             
 
 <div>
       <img  src="./images/finallogo.png" class="img-fluid" style="position:relative;height:40px" >

 </div>
<p style="font-weight: 400;
font-size: 15px;
margin:15px 0px;
 


color: #FFFFFF;
line-height: 26px;
 ">SAYRA APPARELS PVT LTD
</p>
<p style="color:#fff;padding:0px 40px">Village - salempur Gosain, Gajraula, Amroha, Uttar Pradesh - 244235</p>
<div class="d-flex align-items-center justify-content-center mt-4">
  <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-facebook' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-instagram' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-youtube' style="color:#1B1A31;font-size:20px"></i>
  </div>
    <div class="d-flex align-items-center justify-content-center" style="width:30px;height:30px;border-radius:10px;margin:0px 12px;min-width:30px;background:#fff">
      <i class='bx bxl-twitter' style="color:#1B1A31;font-size:20px"></i>
  </div>
</div>

         </div>
       </div>
           


           
         </div>




       </div>

     </div>
   


 
 
  </div>
</div>
</div>
</template>

<script>
 
  import firebase from 'firebase'
   var coderesult

 const fb = require('./firebaseconfig.js')
   import axios from 'axios'
export default {
  props: ['coupondatas','coupons','loadstatus','info','products','category','deals','addcart','test','carts','placestatus','placetext','oldaddrdes','orderplaced','theme'],

  
  data () {

        return{
 phone:'',
            otp:'',
            payloader:false,
            logintype:'send',
            customotp:90922,
            phonetext:'Phone number',
            otptext:'OTP',
             sendotpclicked:false,
              vmphone:'',
       otpenterd:true,
       otpvalue:'',
            errs:false,
            disp:'none',
            otpdes:true,
            opacitybox:false,
            perrs:false,
            user:false,
            loginbox:false,

            user:false,
            pageno:2,
            addrnames:'',
            addrmobile:'',
            mobilenum:'',
            paymenttab:'cash',
            coupontext:'',
            confirmedcoupon:false,
            notavailable:false,
            totalwithoutc:0,
            discountamount:'',
            selectedaddress:{},
            minorderamount:'',
            confirmedcouponcode:'',
            addrpincode:'',
            addrcity:'',
            apply:false,
            deletebox:false,
            addraddress:'',
            emptydata:false,
            tab:'address',
            addbox:false,
            orders:[],
            orderss:[],
            edit:false,
            docid:null,
            address:[],
            filterbox:false,
            filters:[
            {
              name:'All orders',
              selected:true
            },
            {
              name:'Active orders',
              selected:false,
            },
            {
              name:'Completed orders',
              selected:false,
            },
            {
              name:'Failed orders',
              selected:false,
            },
            ]


        }
     
    
  },
  created(){
 
      if(firebase.auth().currentUser){
 



  this.vmphone=firebase.auth().currentUser.displayName


    let cart = window.localStorage.getItem('cart');

var cartstatus= cart ? true : false
 

if(cartstatus){
 
  if(JSON.parse(cart).length==0){
    this.$router.push({ path: '/' })
  }
  

} else{
    this.$router.push({ path: '/' })
}
 

this.mobilenum=firebase.auth().currentUser.phoneNumber


var vm=this

var address=[]

  fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').orderBy('date','desc').onSnapshot(querySnapshot=>{
 address=[]
 var i=0;
    querySnapshot.forEach((doc)=> {
      
 
 

      if(i==0){
            vm.selectedaddress={
              id:doc.id,
              ...doc.data(),selected:true
            }
          address.push({id:doc.id,...doc.data(),selected:true})
        }else{
            address.push({id:doc.id,...doc.data(),selected:false})
        }
        i++
    
        
    })
 
 

vm.address=[
...address
]
})


 




  this.user=true
 }else{

    this.user=false
 }



   },
   computed:{
     paymentmodes(){
      if(this.info.paymentmethods.length==2){

 
        this.paymenttab='online'

      }else{
 
          if(this.info.paymentmethods.includes('ONLINE')){
          this.paymenttab='online'
          }else{
             this.paymenttab='cash'
          }
         
      }
    },
     rendercartlength(){

var cartlength=0
        var x=this.carts.forEach((itm)=>{

           cartlength=Number(itm.quantity)+cartlength
        })
        return cartlength

    },
      rendercoupondatas(){
      return this.coupondatas
    },
    renderabovevalue(){


        return Number(this.info.freedeliveryabove)-Number(this.totalwithoutc)
    },
    renderdelivery(){

 let total=0;
 
for(let item of this.carts){

  total += item.price;
}

 

      if(this.info.deliverystatus){

        if(Number(this.info.freedeliveryabove)<total){

          return 'Free'
        }else{

          return '₹'+this.info.deliveryamount

        }

      }else{
         return 'Free'
      }




    },
totalvalues(){


  let total=0;
 
for(let item of this.carts){

  total += item.price;
}



      if(this.info.deliverystatus){



        if(Number(this.info.freedeliveryabove)<total){

           total=total+0
        
        }else{



  total=total+Number(this.info.deliveryamount)
             
        

        }

      }else{
           total=total+0
      }


if(this.rendercoupondatas.confirmedcoupon){

  if(total>=this.rendercoupondatas.minorderamount){
 total=total-Number(this.rendercoupondatas.discountamount)
  }else{
 
 /*
this.confirmedcouponcode=''
 
this.confirmedcoupon=false

 this.discountamount=''
this.minorderamount=''
*/
  this.$emit('removecoupon')
this.coupontext=''


  }

}
 
this.totalwithoutc=total


var price=total.toString()




  if(price.length==4){
 return price[0]+','+price.slice(1,price.length)
  }
  else if(price.length==5){
 return price.slice(0,2)+','+price.slice(2,price.length)
  }
  else{
     return price
  }







 
},

totalvaluesraz(){


  let total=0;
 
for(let item of this.carts){

  total += item.price;
}



      if(this.info.deliverystatus){



        if(Number(this.info.freedeliveryabove)<total){

           total=total+0
        
        }else{



  total=total+Number(this.info.deliveryamount)
             
        

        }

      }else{
           total=total+0
      }


if(this.rendercoupondatas.confirmedcoupon){

  if(total>=this.rendercoupondatas.minorderamount){
 total=total-Number(this.rendercoupondatas.discountamount)
  }else{
 
 /*
this.confirmedcouponcode=''
 
this.confirmedcoupon=false

 this.discountamount=''
this.minorderamount=''
*/
  this.$emit('removecoupon')
this.coupontext=''


  }

}
 
this.totalwithoutc=total


var price=total.toString()




  if(price.length==4){
 return price[0]+','+price.slice(1,price.length)
  }
  else if(price.length==5){
 return price.slice(0,2)+','+price.slice(2,price.length)
  }
  else{
     return price
  }







 
}
,

totalitemvalues(){


  let total=0;
 
for(let item of this.carts){

  total += item.price;
}


 



var price=total.toString()




  if(price.length==4){
 return price[0]+','+price.slice(1,price.length)
  }
  else if(price.length==5){
 return price.slice(0,2)+','+price.slice(2,price.length)
  }
  else{
     return price
  }







 
}




    

   },
   methods:{
        
      

        closeloginbox(){
      this.loginbox=false
      this.logintype='send'
    },

       

 login(){

 


var vm=this
var randotp=Math.floor(100000 + Math.random() * 900000);
this.sendotpclicked=true
vm.customotp=randotp

    axios.get('https://www.fast2sms.com/dev/bulkV2?authorization=bVo7GRmXxBWqwS3AiIfEaNeKvU8hHrgQ2ZkuFcPlp45d1M6yOYp5em7qztEDaJBSQdZfRVX3vjxs6Lkw&sender_id=iSAYRA&message=132422&variables_values='+vm.customotp+'&route=dlt&numbers='+vm.phone).then(function (response) {
 if(response.data.message.includes('SMS sent successfully.')){
  vm.logintype='otp'


            console.log(response)
 vm.sendotpclicked=false
}else{
  alert(response.data.message)
}


 

 })
},
 subotp(value){
      this.otpenterd=true
      this.otpvalue=value
    },

subotps(value){
 
var vm=this;

var already=false

 
if(vm.customotp==vm.otpvalue){



fb.db.collection("client5").where("email", "==",'+91'+vm.phone+'@sayra.com' )
    .get()
    .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {

          already=true
            console.log(doc.id, " => ", doc.data());
        });



     //   alert(already)
        if(already){



          fb.auth.signInWithEmailAndPassword('+91'+vm.phone+'@sayra.com', '+91'+vm.phone,)
  .then((userCredential) => {
    // Signed in 
    var user = userCredential.user;

           
       
 vm.logintype='send'
 vm.loginbox=false
 
 
       vm.phone=''


var address=[]

 
 fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').orderBy('date','desc').onSnapshot(querySnapshot=>{
 address=[]
 var i=0;
    querySnapshot.forEach((doc)=> {
      
 
 

      if(i==0){
            vm.selectedaddress={
              id:doc.id,
              ...doc.data(),selected:true
            }
          address.push({id:doc.id,...doc.data(),selected:true})
        }else{
            address.push({id:doc.id,...doc.data(),selected:false})
        }
        i++
    
        
    }) 
 
 

vm.address=[
...address
]

})



 
  })
   



        }else{

          fb.auth.createUserWithEmailAndPassword('+91'+vm.phone+'@sayra.com', '+91'+vm.phone,)
  .then((userCredential) => {
    // Signed in 
    var user = userCredential.user;

    user.updateProfile({
   displayName:'+91'+vm.phone
 })

           

           fb.db.collection("client5").doc(fb.auth.currentUser.uid).set({
            email:'+91'+vm.phone+'@sayra.com'
           })
       
 vm.logintype='send'
 vm.loginbox=false
 
vm.$router.push({ path: '/account' })

       vm.phone=''



 
  })
   



        }
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });













}else{
  vm.perrs=true
      vm.otptext='Invalid Otp'
      vm.otpvalue=''
      console.log('errorr')
       console.log(error.message);
       vm.otpenterd=false
       setTimeout(()=>{
         vm.perrs=false
       },3000)

}
 
 
 
  

},

addressbox(){
      if(firebase.auth().currentUser){
        this.addbox=true
        }else{
this.loginbox=true
        }

},

    gotobag(){
  this.$router.go(-1)

    },

changetab(tabname){

if(tabname=='address'){
 
  this.tab=tabname
  this.pageno=2
}else{
 
 if(firebase.auth().currentUser){
   this.tab=tabname
  this.pageno=3
}else{
this.loginbox=true
}
}


},
async loadpaytm(){
      return new Promise(resolve=>{
        const script = document.createElement('script')
        script.src = 'https://securegw.paytm.in/merchantpgpui/checkoutjs/merchants/DGIeUl00317208727172.js'
        script.onload = () =>{
          resolve(true)
        }
        script.onerror = () =>{
          resolve(false)
        }        
        document.body.appendChild(script)
      })      
  
  },
 
 async placeorder(){
   
if(fb.auth.currentUser){


if(this.paymenttab=='cash'){

 

  let total=0;
 var deliverystatus=''



 var pricing={
  

}

for(let item of this.carts){

  total += item.price;
}



      if(this.info.deliverystatus){



        if(Number(this.info.freedeliveryabove)<total){

           total=total+0
           deliverystatus='Free'
        
        }else{


deliverystatus= Number(this.info.deliveryamount)
  total=total+Number(this.info.deliveryamount)
             
        

        }

      }else{
        deliverystatus='Free'
           total=total+0
      }




if(this.rendercoupondatas.confirmedcoupon){


pricing={
  couponapplied:{
      
      ...this.rendercoupondatas,
      status:true


  }
}

  if(total>=this.rendercoupondatas.minorderamount){

 total=total-Number(this.rendercoupondatas.discountamount)


  } 

}else{

pricing={
  couponapplied:{

      status:false


  }
}
}


 
  pricing={
    ...pricing,

  deliveryamount:deliverystatus,
      paymentmode:'cod',

  total:total,

}

 
 
 this.$emit('addressformob',[this.selectedaddress,pricing])
 


}else{




  


var vm=this
 
this.payloader=true

 
 /*
 var options = {
  "vm":vm,
    "key": "rzp_live_FGlxjUQOcuVL3f", // Enter the Key ID generated from the Dashboard
    "amount": vm.totalvaluesraz*100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
    "currency": "INR",
    "name": "Sayra",
    "description": "Sayra",
     
     "handler": function (response){
     
    this.payloader=false
 
 
  let total=0;
 var deliverystatus=''



 var pricing={
  

}

for(let item of vm.carts){

  total += item.price;
}



      if(vm.info.deliverystatus){



        if(Number(vm.info.freedeliveryabove)<total){

           total=total+0
           deliverystatus='Free'
        
        }else{


deliverystatus= Number(vm.info.deliveryamount)
  total=total+Number(vm.info.deliveryamount)
             
        

        }

      }else{
        deliverystatus='Free'
           total=total+0
      }




if(vm.rendercoupondatas.confirmedcoupon){


pricing={
  couponapplied:{
      
      ...vm.rendercoupondatas,
      status:true


  }
}

  if(total>=vm.rendercoupondatas.minorderamount){

 total=total-Number(vm.rendercoupondatas.discountamount)


  } 

}else{

pricing={
  couponapplied:{

      status:false


  }
}
}


 
  pricing={
    ...pricing,

  deliveryamount:deliverystatus,
    paymentmode:'online',
    

  total:total,

}

  vm.payloader=true

 
 vm.$emit('addressformob',[vm.selectedaddress,pricing])
 

 


     },
    "prefill": {
                   "email": "support@sayra.in",
                   "contact": vm.vmphone,
              },
    "notes": {
        "address": "Sayra"
    },
    "theme": {
       "color": "#eb3838"
    }
};


var rzp1 = new Razorpay(options);
rzp1.open();

 */
 

 
var statuss=await this.loadpaytm()

if(statuss){



 axios.get('https://us-central1-course-wings.cloudfunctions.net/initialpaytm?amount='+vm.totalvaluesraz).then((response)=>{
 
  console.log(response)


var config = {
  "root": "",
  "flow": "DEFAULT",
  "data": {
    "orderId": response.data.orderid, 
    "token": response.data.txntoken, 
    "tokenType": "TXN_TOKEN",
    "amount": response.data.amount 
    },
    "merchant":{
    "redirect": false
  },
   "payMode":{
    "order": ['UPI','CARD','NB','PDC','PPBL','BALANCE']
  } ,
  "handler": {
     transactionStatus:function(data){
      self.close();
        console.log("payment status ", data); 
        if(data.STATUS=="TXN_SUCCESS") {


   this.payloader=false
 
 
  let total=0;
 var deliverystatus=''



 var pricing={
  

}

for(let item of vm.carts){

  total += item.price;
}



      if(vm.info.deliverystatus){



        if(Number(vm.info.freedeliveryabove)<total){

           total=total+0
           deliverystatus='Free'
        
        }else{


deliverystatus= Number(vm.info.deliveryamount)
  total=total+Number(vm.info.deliveryamount)
             
        

        }

      }else{
        deliverystatus='Free'
           total=total+0
      }




if(vm.rendercoupondatas.confirmedcoupon){


pricing={
  couponapplied:{
      
      ...vm.rendercoupondatas,
      status:true


  }
}

  if(total>=vm.rendercoupondatas.minorderamount){

 total=total-Number(vm.rendercoupondatas.discountamount)


  } 

}else{

pricing={
  couponapplied:{

      status:false


  }
}
}


 
  pricing={
    ...pricing,

  deliveryamount:deliverystatus,
    paymentmode:'online',
    

  total:total,

}

  vm.payloader=true

  document.getElementById('app-close-btn').click()

 vm.$emit('addressformob',[vm.selectedaddress,pricing])
 


        }else{
              document.getElementById('app-close-btn').click()
               vm.$router.push({path:'/paymentfailure'})
        }
      },
  "notifyMerchant": function(eventName,data){

    console.log("notifyMerchant handler function called");
    console.log("eventName => ",eventName);
    console.log("data => ",data);


 if(eventName=='APP_CLOSED'){
          vm.payloader=false
      }


    }
  }
};
  if(window.Paytm && window.Paytm.CheckoutJS){
    // initialze configuration using init method 
    window.Paytm.CheckoutJS.init(config).then(function onSuccess() {
      // after successfully updating configuration, invoke checkoutjs
      window.Paytm.CheckoutJS.invoke();

      
    }).catch(function onError(error){
      console.log("error => ",error);
    });
}





 })











}



}


}else{
 
 this.$router.push({ path: '/login' })


}



 },

    selectaddress(item){

  this.address=this.address.map((itm)=>{

        if(itm.id==item.id){
          return {
            ...itm,
            selected:true
          }
        }else{
          return {
            ...itm,
            selected:false
          }
        }
      })
        this.selectedaddress={
          ...item
        }
    },




   applycoupon(item){
 

 var x=this.totalitemvalues.split(',')
 var amount=''
 for(var i=0;i<x.length;i++){

amount=amount+x[i]

 }
 
if(Number(amount) >=item.minorderamount)
{



 


var couponlocal={

confirmedcouponcode:item.couponcode,
confirmedcoupon:true,
discountamount:item.discountamount,
minorderamount:item.minorderamount,

}



  this.$emit('setcoupon',couponlocal)




this.coupontext=''


this.apply=false

 
 



}else{
  alert('s')
}




    },
    removecoupon(){



  this.$emit('removecoupon')


 
this.coupontext=''

 
    },

    checkcoupon(){
 


var x=this.coupons.filter((itm)=>{
  return itm.couponcode.toLowerCase()==this.coupontext.toLowerCase()
})


if(x.length>0 ){
 


 var xs=this.totalitemvalues.split(',')
 var amount=''
 for(var i=0;i<xs.length;i++){

amount=amount+xs[i]

 }
 

 if(Number(amount)>=x[0].minorderamount)
{




 




var couponlocal={

confirmedcouponcode:x[0].couponcode,
confirmedcoupon:true,
discountamount:x[0].discountamount,
minorderamount:x[0].minorderamount,

}
  this.$emit('setcoupon',couponlocal)


this.coupontext=''
this.apply=false
 this.notavailable=false

}else{
  alert('s')
}



}else{

 
 this.notavailable=true
 
 

}

    },


add(item){

 this.$emit('addcart',item)
  
 


         
    },
    sub(item){

 this.$emit('subcart',item)
 
  }
  ,
async signout(){
  await firebase.auth().signOut()

  this.$router.push({ path: '/' })

},
    async finaldelete(){
         await fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').doc(this.docid).delete()

         this.deletebox=false
    },
    deleteaddress(item){
 

        this.deletebox=true

        this.docid=item.id

 

 


    },
    editaddress(item){


var vm=this
         this.edit=true
        this.docid=item.id

 
  vm.addrnames=item.name
 
  vm.addrmobile=item.mobile
 vm.addrpincode=item.pincode
   vm.addrcity=item.city
 vm.addraddress=item.address

vm.addbox=true



    },
   async addaddress(){


var vm=this
    if(this.edit){
 
 


 await fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').doc(vm.docid).update({

  name:vm.addrnames,
  mobile:vm.addrmobile,
  pincode:vm.addrpincode,
  city:vm.addrcity,
  address:vm.addraddress,
  date:new Date()

 })

 await fb.db.collection('client5').doc(firebase.auth().currentUser.uid).update({

  name:vm.addrnames,
  mobile:vm.addrmobile,
  pincode:vm.addrpincode,
  city:vm.addrcity,
  address:vm.addraddress,
  date:new Date()

 })


 vm.addrnames=''
  vm.addrmobile=''
 vm.addrpincode=''
   vm.addrcity=''
 vm.addraddress=''

 vm.addbox=false
   this.edit=false
        this.docid=null





         }else{




      var vm=this
 

 

 await fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').add({

  name:vm.addrnames,
  mobile:vm.addrmobile,
  pincode:vm.addrpincode,
  city:vm.addrcity,
  address:vm.addraddress,
  date:new Date()

 })


 await fb.db.collection('client5').doc(firebase.auth().currentUser.uid).update({

  name:vm.addrnames,
  mobile:vm.addrmobile,
  pincode:vm.addrpincode,
  city:vm.addrcity,
  address:vm.addraddress,
  date:new Date()

 })


 vm.addrnames=''
  vm.addrmobile=''
 vm.addrpincode=''
   vm.addrcity=''
 vm.addraddress=''

 vm.addbox=false





    }
    },
    closeaddbox(){
      this.addbox=false

    },
    filterorder(item){


var y=this.filters.map((itms)=>{

  if(item.name==itms.name){
    return {
      ...itms,
      selected:true
    }
  }else{
     return {
      ...itms,
      selected:false
    }
  }
})
     

if(item.name=='All orders'){


 var x=[
 ...this.orderss
 ]

}
else if(item.name=='Completed orders'){

   var x=this.orderss.filter((itm)=>{

          return itm.status=='Delivered' 
 })
}
else if(item.name=='Active orders'){

   var x=this.orderss.filter((itm)=>{

          return itm.status=='Accepted'|| itm.status=='pending' || itm.status=='Shipped'

 })
}
else{
 var x=this.orderss.filter((itm)=>{

          return itm.status=='Rejected'|| itm.status=='Cancelled' || itm.status=='Not Delivered'

 })

}
 
 
 
      this.orders=[
      ...x
      ]
      this.filters=[
      ...y
      ]

      this.filterbox=false

    },

  account(){


     if(firebase.auth().currentUser){

//alert('yes')


this.$router.push({ path: '/account' })

 }else{
this.loginbox=true
 }
    },
    
     renderdate(timestamp){

      var date=timestamp.toDate();
      var stringdate=date.getDate()+'/'+date.getMonth()+'/'+date.getFullYear()
      var today=new Date()
      var stringtoday=today.getDate()+'/'+today.getMonth()+'/'+today.getFullYear()
      var yesterday=new Date()
      yesterday.setDate(yesterday.getDate() - 1);


      var stringyesterdayday=yesterday.getDate()+'/'+yesterday.getMonth()+'/'+yesterday.getFullYear()
 
 

if(stringdate==stringtoday){
 
 return 'Today, '+ date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
 
}else if(stringyesterdayday==stringdate){

 
 return 'Yesterday, '+date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

   
}else{

return stringdate+', '+date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

}

     

    },

  
      logout(){
        var vm=this

        fb.auth.signOut().then(function() {
 
vm.user=false
vm.$router.push({ path: '/'  })

}).catch(function(error) {
 
});
      }
   }


   
    
 
  
}
</script>
<style scoped >


</style>
 



// WEBPACK FOOTER //
// src/address.vue